import {
  FileText,
  User,
  Grid,
  Settings,
  LayoutDashboard,
  Truck,
} from "lucide-react";
import { message } from "antd";
import PERMISSIONS from '../lib/permissions.json';
import useAuth from "./useAuth";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export default function useNav () {
  const { checkUserPermission } = useAuth();
  const location = useLocation();

  const NAV_ITEMS = [
    {
        icon: LayoutDashboard,
        href: "/admin/dashboard",
        label: "dashboard",
        isPermitted: checkUserPermission(PERMISSIONS.DASHBOARD_READ)
    },
    {
        icon: FileText,
        href: "/admin/requests",
        label: "requests",
        isPermitted: checkUserPermission(PERMISSIONS.REQUESTS_READ)
    },
    {
        icon: Truck,
        href: "/admin/trucks",
        label: "trucks",
        isPermitted: checkUserPermission(PERMISSIONS.TRUCKS_READ)
    },
    {
        icon: Grid,
        href: "/admin/zones",
        label: "zones",
        isPermitted: checkUserPermission(PERMISSIONS.ZONES_READ)
    },
    {
        icon: User,
        href: "/admin/users",
        label: "users",
        isPermitted: checkUserPermission(PERMISSIONS.USERS_READ)
    },
    {
        icon: Settings,
        href: "/admin/settings",
        label: "settings",
        isPermitted: checkUserPermission(PERMISSIONS.SETTINGS_READ)
    },
  ];

  const navItems = useMemo(() => {
    return NAV_ITEMS.filter(nav => nav.isPermitted);
  }, [NAV_ITEMS]);

  const unAccessibleNav = useMemo(() => {
    return NAV_ITEMS.filter(nav => !nav.isPermitted);
  }, [NAV_ITEMS]);


  const isActiveNav = (url: string) => {
    return location.pathname.includes(url);
  }  

  return {
    navItems,
    location,
    isActiveNav,
    unAccessibleNav
  } 
}